import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-68" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-69" data-mp="3ghc2o28413o8">
        <p className="font-display text-xl font-black text-plum" data-id="element-70" data-mp="32m1bayt2r0om">
          THE MENORESET SYSTEM<span className="align-super text-xs" data-id="element-71" data-mp="36ppnjusnikg7">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-72" data-mp="3ug3fzmf5elbb">
          The natural visual method to reset your hormones from absolute zero: metabolic cooling,
          circadian deep sleep, brain fog protection, and metabolism safeguard in 30 days.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-73" data-mp="3qcnlavmn2v19">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-74" data-mp="29y5fdwbbxcsw">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-75" data-mp="3l9k6jf1oprec" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-76" data-mp="3gagzxq623d49">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-77" data-mp="3v89fujfim3iz" /> @sigmasmart.en
          </a>
          
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-78" data-mp="3q7lmvs7q7cm4">
          🌿 “Your vibrant health starts today.”
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-79" data-mp="80xmgfnmfdms">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-80" data-mp="31umvaqetzm7">
            Terms & Conditions
          </a>
          <span data-id="element-81" data-mp="ct77pidsjpiq">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-82" data-mp="cv1rgtdbtbl8">
            Privacy Policy
          </a>
          <span data-id="element-83" data-mp="qrfba95c1p2v">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-84" data-mp="mrwmh2ae4tur">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-85" data-mp="tw618ehn64qf">
          © 2026 THE MENORESET SYSTEM™ — SIGMA SMART™ — All rights reserved. Reproduction and
          redistribution prohibited without express authorization.
        </p>
      </div>
    </footer>;
}